import { Checkbox } from "@primer/react";

export const usersTableConfig = () => {
    return [
        {
            id: "select",
            field: "",
            sortBy: "basic",
            header: () => <Checkbox value="default" disabled />,
            rowHeader: true,
            maxWidth: 40
        },
        {
            id: "name",
            header: "Имя",
            field: "name",
            sortBy: "basic",
            rowHeader: true,
        },
        {
            id: "phone",
            header: "Номер телефона",
            field: "phone",
            sortBy: "basic",
        },
        {
            id: "email",
            header: "E-mail",
            field: "email",
        },
        {
            id: "status",
            header: "Статус",
            field: "status",
        },
        {
            id: "address",
            header: "Адрес",
            field: "address",
            sortBy: "basic",
        },
        {
            id: "date",
            header: "Дата регистрации",
            field: "date",
            sortBy: "datetime",
        },
    ];
}
